const data = [
    {question:"Which App Do you have ?",
    answer:["facebook","whatsapp","linkedin","Instagram"]},
    {question:"Do you have Linkedin ?",
    answer:["yes","no"]},
];

export default data;